import logoSBA from "@assets/events-awards/logo-sba.svg";
import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render SBA about page
 */
const SBAAboutPage = (): React.ReactElement => {
  return (
    <div data-testid="sba-about-page-component" className="font-public-sans">
      <div>
        <BlockTitle
          text="About"
          rootClassName="py-3 pb-1 text-4xl text-xl lg:text-8xl font-medium"
        />

        <p>
          The Singapore Business Awards (SBA) is jointly organised by The
          Business Times, a business daily published by SPH Media Limited, and
          DHL, the global market leader of the international express and
          logistics industry. SBA has grown in stature to become Singapore’s
          most prestigious accolades in the business and corporate sectors.
        </p>

        <p>The awards comprise:</p>

        <ul className="list-outside list-disc pl-8">
          <li>Businessman Of The Year</li>
          <li>Outstanding Chief Executive Of The Year</li>
          <li>Outstanding Overseas Executive Of The Year</li>
          <li>The Enterprise Award</li>
          <li>Young Business Leader Of The Year</li>
        </ul>
      </div>

      <div className="my-14">
        <img
          src={logoSBA}
          alt="Singapore Business Awards logo"
          width={581}
          height={200}
        />
      </div>

      <BlockTitle
        text="Objectives"
        rootClassName="pb-3 pb-1 text-4xl text-xl lg:text-8xl font-medium"
      />

      <div>
        <p>
          The SBA was launched in 1985, starting with The Businessman of the
          Year Award. The following year, the Enterprise Award was introduced to
          give recognition to small- and medium-sized enterprises. In 1990, a
          new category - the Outstanding Manager Award - was introduced to give
          recognition to professional managers. This was renamed Outstanding
          Chief Executive of the Year in 1995.
        </p>

        <p>
          The Outstanding Chief/Senior Executive (Overseas) Award, introduced in
          2005, recognises an outstanding Singaporean who works overseas. The
          award was renamed Outstanding Overseas Executive Award in 2017.
        </p>

        <p>
          The four awards, known collectively as the Singapore Business Awards,
          are decided by a panel of judges drawn from the business sector,
          official agencies and academia.
        </p>

        <p>The objectives of the Singapore Business Awards are:</p>

        <ul className="list-outside list-disc pb-6 pl-8">
          <li>
            To acknowledge the vital contributions made by companies and
            business leaders to Singapore&apos;s development;
          </li>
          <li>
            To encourage the entrepreneurial spirit in Singapore, and to give
            recognition to excellence in corporate management
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SBAAboutPage;
